<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="分组名称">
                <el-input v-model="formInline.groupName" placeholder="分组名称"></el-input>
            </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <!--<el-button type="success" @click="handleAdd">新增</el-button>-->
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformId" label="平台" :formatter="platformShow" width="100"></el-table-column>
                <el-table-column prop="groupName" label="分组名称" ></el-table-column>
                <el-table-column prop="markStatus" label="是否同时标记" :formatter="statusShow" ></el-table-column>
                <el-table-column prop="updateTime" label="更新日期" sortable  width="150"></el-table-column>
                <el-table-column prop="operater" label="操作人" sortable  width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="warning"  size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分组名称">
                    <el-input type="text" v-model=form.groupName clearable  placeholder="分组名称" maxlength="40"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否同时标记">
                    <el-select v-model="form.markStatus"  placeholder="是否同时标记优惠券和连接" >
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getPlatformList,getDistributorGroupPageList,deleteDistributorGroup,saveDistributorGroup,getDistributorGroup} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                loading:true,
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                dialogFormVisible:false,
                form:{"id":null,"groupName":""},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    platformId:1
                },
                platformDisabled:false,

            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                getDistributorGroupPageList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;

                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if(confirm("确定删除:"+row.groupName+"吗？")) {
                    deleteDistributorGroup({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }

            },
            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.id=null;
                this.form.groupName='';
                this.form.platformId=1;

            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getDistributorGroup({id:data.id}).then((res) => {
                    //console.log(res.data);
                    if(res.data.value!=undefined) {
                        this.form = res.data.value;
                    }
                });
            },

            save(data){
                console.log(data);
                if(data.groupName==""){
                    this.$message({
                        message:"请输入分组名称",
                        type:'error'
                    });
                    return;
                }


                saveDistributorGroup(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },
            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;

            },

            platformShow(row,column,cellValue){
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
            }


        }
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/tagGroup.vue